import { Injectable } from '@angular/core';
import {
  ApplicationsService,
  YardAPIApplicationUserManagementGetApplicationsModelsApplication,
} from '@dot/yard-api-client';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppsService {
  public applications: YardAPIApplicationUserManagementGetApplicationsModelsApplication[] = [];

  constructor(private applicationsService: ApplicationsService) {}

  public async getApplications() {
    try {
      this.applications = await lastValueFrom(this.applicationsService.getApplicationsAsync());
    } catch (error) {
      console.warn(error);
    }
    this.applications.sort((a, b) => {
      if (a.applicationName < b.applicationName) {
        return -1;
      }
      if (a.applicationName > b.applicationName) {
        return 1;
      }
      return 0;
    });
  }
}
